// @ts-nocheck
import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'
import IconComponent from '../../themes/IconComponent'

// assets
const OnlinePaymentIcon = (props) => <IconComponent asset="/icons/onlinePayment.svg" {...props} />

const SvgOnlinePaymentIcon = (props) => <SvgIcon component={OnlinePaymentIcon} viewBox="0 0 23 16" {...props} />

export default SvgOnlinePaymentIcon
